import { Endpoints } from "../Endpoints";
import Backend from "../../Backend";

export default class Purchaser {
    constructor(token) {
        this.backend = new Backend(token);
    }

    all(callback) {
        this.backend.callBackend(`${Endpoints.purchaser.private}/all`, callback)
    }

    purchaser(id, callback) {
        this.backend.callBackend(`${Endpoints.purchaser.private}/id/${id}`, callback)
    }

    address(id, callback) {
        this.backend.callBackend(`${Endpoints.purchaser.private}/${id}/address`, callback)
    }
    billingaddress(id,callback){
        this.backend.callBackend(`${Endpoints.purchaser.private}/${id}/purchaser-billing-address/get-all`, callback)
    }

    contacts(id, callback) {
        this.backend.callBackend(`${Endpoints.purchaser.private}/${id}/contacts`, callback)
    }
    payment(id,callback) {
         this.backend.callBackend(`${Endpoints.purchaser.payment}/${id}/all/transactions`, callback, "GET")
    }
    invoice(id,callback){
        this.backend.callBackend(`${Endpoints.purchaser.payment}/${id}/admin/all`, callback, "GET")
    }
    uploadinvoice(file, id, callback){
        const data = new FormData();
		data.append('file', file);
		
        this.backend.callBackend(`${Endpoints.purchaser.payment}/${id}/upload-invoice`,callback, "POST", data, false)
    }
    downloadinvoice(id,callback){
        this.backend.callBackend(`${Endpoints.purchaser.payment}/${id}/download-invoice`,callback)
    }
    statusUpdate(id,orderId,callback){
        this.backend.callBackend(`${Endpoints.purchaser.payment}/${id}/${orderId}/add`, callback, "POST") 
    }

    bannedBrandsByPurchaser(id, callback) {
        this.backend.callBackend(`${Endpoints.purchaser.brand}/catalog/purchaser/${id}`, callback)
    }

    contactTypes(callback) {
        this.backend.callBackend(`${Endpoints.purchaser.private}/contact/types`, callback)
    }

    bannedCardsByPurchaser(purchaserId, callback) {
        this.backend.callBackend(`${Endpoints.purchaser.card}/purchaser/${purchaserId}`, callback)
    }
    purchaserDetailsApi(purchaserId,currentItem, callback) {
        this.backend.callBackend(`${Endpoints.purchaser.private}/${purchaserId}/purchaser-profile?size=${currentItem}`, callback)
    }


    bestBrandsByPurchaser(purchaserId, callback) {
        this.backend.callBackend(`${Endpoints.purchaser.bestBrand}/purchaser/${purchaserId}`, callback)
    }

    cardsByBrandByPurchaser(purchaserId, brandId, callback) {
        this.backend.callBackend(`${Endpoints.purchaser.card}/purchaser/${purchaserId}/purchaserBrand/${brandId}`, callback)
    }

    allUsers(callback) {
        this.backend.callBackend(`${Endpoints.purchaser.private}/users`, callback)
    }

    users(id, callback) {
        this.backend.callBackend(`${Endpoints.purchaser.private}/${id}/users`, callback)
    }

    availableBrands(id, callback) {
        this.backend.callBackend(`${Endpoints.purchaser.brand}/catalog/purchaser/${id}/brands`, callback)
    }

    purchaserDashboard(id, callback) {
        this.backend.callBackend(`${Endpoints.purchaser.private}/${id}/dashBoard`, callback)
    }
    purchaserDashboardBrand(id,callback){
        let body = {}
        this.backend.callBackend(`${Endpoints.purchaser.private}/${id}/catalog/available/`, callback,'POST',body)
    }
    allFunds(id,callback){
        this.backend.callBackend(`${Endpoints.purchaser.private}/funds/${id}`, callback)
    }

    supplierAvailableBrands(id, callback) {
        this.backend.callBackend(`${Endpoints.purchaser.brand}/catalog/purchaser/${id}/suppliers/brands`, callback)
    }

    activeBrands(filters, id, callback) {
        this.backend.callBackend(`${Endpoints.purchaser.private}/${id}/catalog/available`,  callback, 'POST', filters)
    }

    activeCards(id, callback) {
        this.backend.callBackend(`${Endpoints.purchaser.card}/purchaser/${id}/gift-cards`, callback)
    }

    contactByCognito(username, callback) {
        this.backend.callBackend(`${Endpoints.purchaser.private}/contact/${username}`, callback)
    }

    add(data, callback) {
        this.backend.callBackend(`${Endpoints.purchaser.private}/`, callback, 'POST', data)
    }

    ThirdPartyInfo(data,callback){
        this.backend.callBackend(`${Endpoints.purchaser.thirdParty}/`, callback, 'POST', data)
    }
    infoUpdate(data,callback){
        this.backend.callBackend(`${Endpoints.purchaser.thirdParty}/`, callback, 'PATCH', data) 
    }
    thirdinforegion(id,callback){
        this.backend.callBackend(`${Endpoints.catalog.region}/country/${id}`, callback)
    }
    thirdinforCountry(callback){
        this.backend.callBackend(`${Endpoints.catalog.infocountry}`, callback)
    }
    getThirdPartyinfo(id,callback){
        this.backend.callBackend(`${Endpoints.purchaser.thirdParty}/purchaser/${id}`, callback,)
    }
    fundDetails(data,id,callback){
        this.backend.callBackend(`${Endpoints.purchaser.private}/funds/create/${id}`, callback, 'POST', data)
    }

    getFundDetails(id,callback){
        this.backend.callBackend(`${Endpoints.purchaser.private}/funds/${id}`, callback)
    }
    getpaymentmode(id,callback){
        this.backend.callBackend(`${Endpoints.purchaser.private}/id/${id}`, callback)
    }

    getpaymentmode(id,callback){
        this.backend.callBackend(`${Endpoints.purchaser.private}/id/${id}`, callback)
    }

    updateFund(data,id,callback){
        this.backend.callBackend(`${Endpoints.purchaser.private}/funds/update/${id}`, callback, 'PATCH', data)  
    }
    newUpdateFunds(data,id,callback){
        this.backend.callBackend(`${Endpoints.purchaser.private}/funds/update/${id}`, callback, 'PATCH', data)    
    }

    addAddress(data, callback) {
        this.backend.callBackend(`${Endpoints.purchaser.private}/address`, callback, 'POST', data)
    }

    addContact(purchaserId, data, callback) {
        this.backend.callBackend(`${Endpoints.purchaser.private}/${purchaserId}/contacts`, callback, 'POST', data)
    }

    addBrand(data, callback) {
        this.backend.callBackend(`${Endpoints.purchaser.brand}`, callback, 'POST', data)
    }

    addCard(data, callback) {
        this.backend.callBackend(`${Endpoints.purchaser.card}`, callback, 'POST', data)
    }

    addPurchaserUser(purchaserId, contactId, data, callback) {
        this.backend.callBackend(`${Endpoints.purchaser.private}/${purchaserId}/contact/${contactId}/user`, callback, 'POST', data)
    }
//////
    updatePurchaserContactInfo(data, callback) {
        this.backend.callBackend(`${Endpoints.purchaser.private}/address`, callback, 'PUT', data)
    }
    updatePurchaserBillingInfo(purchaserId, data, callback) {
        this.backend.callBackend(`${Endpoints.purchaser.private}/${purchaserId}/purchaser-billing-address`, callback, 'PUT', data)
    }
//////
    updateUserInfo(data,callback){
        this.backend.callBackend(`${Endpoints.purchaser.userInfo}/change-email-phone`, callback, 'POST', data)
    }
    addPurchaserClientUser(contactId, data, callback) {
        this.backend.callBackend(`${Endpoints.auth.signup}/purchaser-client/${contactId}`, callback, 'POST', data)
    }

		uploadFundsFile(file, callback) {
			this.backend.callBackend(`${Endpoints.purchaser.private}/upload`, callback, "PUT", file, false );
		}

    disableUser(purchaserId, contactId, callback) {
        this.backend.callBackend(`${Endpoints.purchaser.private}/${purchaserId}/contact/${contactId}/user/disable`, callback, 'PUT')
    }

    resendTemperaryCredentials(purchaserId, contactId,firstName,lastName,username,phoneNumber, callback) {
        let body={
            "firstName": firstName,
            "lastName": lastName,
            "username": username,
            "phoneNumber": phoneNumber
        }
        this.backend.callBackend(`${Endpoints.purchaser.private}/${purchaserId}/contact/${contactId}/user/resendMail`, callback, 'POST', body)
    }       

    update(data, callback) {
        this.backend.callBackend(`${Endpoints.purchaser.private}/`, callback, 'PUT', data)
    }

    updatebillingAddress(data,id,callback){
        this.backend.callBackend(`${Endpoints.purchaser.private}/${id}/purchaser-billing-address`, callback, 'PUT', data)
    }

    updateContact(purchaserId, data, callback) {
        this.backend.callBackend(`${Endpoints.purchaser.private}/${purchaserId}/contacts`, callback, 'PUT', data)
    }

    updateContactId(purchaserId, data, callback) {
        this.backend.callBackend(`${Endpoints.purchaser.private}/${purchaserId}/contacts/update`, callback, 'POST', data)
    }

    updateAddress(data, callback) {
        this.backend.callBackend(`${Endpoints.purchaser.private}/address`, callback, 'PUT', data)
    }

    updateBrand(data, callback) {
        this.backend.callBackend(`${Endpoints.purchaser.brand}`, callback, 'PUT', data)
    }

    updateCard(data, callback) {
        this.backend.callBackend(`${Endpoints.purchaser.card}`, callback, 'PUT', data)
    }

    setNewPrimary(purchaserId, contactId, contactTypeId, callback) {
        this.backend.callBackend(`${Endpoints.purchaser.private}/${purchaserId}/contacts/${contactId}/primary/${contactTypeId}`, callback, 'PUT')
    }

    remove(id, callback) {
        this.backend.callBackend(`${Endpoints.purchaser.private}/${id}`, callback, 'DELETE')
    }

    removeBrand(id, callback) {
        this.backend.callBackend(`${Endpoints.purchaser.brand}/${id}`, callback, 'DELETE')
    }

    removeCard(id, callback) {
        this.backend.callBackend(`${Endpoints.purchaser.card}/${id}`, callback, 'DELETE')
    }

    removeContact(purchaserId, id, callback) {
        this.backend.callBackend(`${Endpoints.purchaser.private}/${purchaserId}/contacts/${id}`, callback, 'DELETE')
    }

    getAllBrandsLimits(id, callback){
        this.backend.callBackend(`${Endpoints.brand.limit}/purchaser/${id}`, callback)
    }

    getDiscountByBrand(id, callback){
        this.backend.callBackend(`${Endpoints.brand.limit}/${id}`, callback)
    }

    createBrandsLimits(data, callback){
        this.backend.callBackend(`${Endpoints.brand.limit}`, callback, 'POST', data)
    }

    deteleBrandsLimits(id, callback){
        this.backend.callBackend(`${Endpoints.brand.limit}/${id}`, callback, 'DELETE')
    }
    deleteFundsdetails(id,callback){
        this.backend.callBackend(`${Endpoints.purchaser.private}/funds/${id}`, callback, 'DELETE')  
    }
    uploadBrandLimits(purchaserId, data, callback){
        this.backend.callBackend(`${Endpoints.brand.limit}/upload/${purchaserId}`, callback, 'POST', data , false)
    }
    uploadCSVRealtime(orderID,data,callback){
        this.backend.callBackend(`${Endpoints.brand.realtime}/upload-csv-realtime/${orderID}`, callback, 'POST', data , false)
    }
    downloadBrandLimits(purchaserId, callback){
        this.backend.callBackend(`${Endpoints.brand.limit}/download/${purchaserId}`, callback )
    }

    getHistoryBySKU(id, callback){
        this.backend.callBackend(`${Endpoints.purchaser.history}/${id}`, callback)
    }
    getPurchaseHistoryBySKU(sku, startDate, endDate, callback){
        this.backend.callBackend(`${Endpoints.purchaser.history}/${sku}/from/${startDate}/to/${endDate}`, callback)
    }

    allNotificationContact(purchaserId, callback) {
        this.backend.callBackend(`${Endpoints.purchaser.private}/allNotificationContact/${purchaserId}`, callback)
    }

    purchaserNotificationList(id, callback) {
        this.backend.callBackend(`${Endpoints.purchaser.notifiactionList}/${id}`, callback, 'GET')
    }
    allnotification(seletradio,callback){
        this.backend.callBackend(`${Endpoints.purchaser.private}/enable/notification`,callback, "POST",seletradio)
    }
    findCurrency(purchaserId,callback){
        this.backend.callBackend(`${Endpoints.purchaser.funds}/currency/${purchaserId}`,callback, 'GET')
    }

   notification(callback){
    this.backend.callBackend(`${Endpoints.purchaser.Notification}`, callback, 'GET')
   }

   postNotification(data,callback){
    this.backend.callBackend(`${Endpoints.purchaser.Notification}`, callback, 'POST',data)
   }
   delNotification(id,type,callback){
    this.backend.callBackend(`${Endpoints.purchaser.Notification}/${id}/${type}`, callback, 'DELETE')
   }
   lowFundCustomer(id,data,callback){
    this.backend.callBackend(`${Endpoints.purchaser.private}/funds/${id}`, callback, 'PATCH',data)
   }
   InventoryBrand(data,callback){
    this.backend.callBackend(`${Endpoints.brand.inventory}/brand`, callback, 'POST', data)
   }
   InventoryWhiteBrand(data,callback){
    this.backend.callBackend(`${Endpoints.brand.inventory}/whitelist-brand`, callback, 'POST', data)
   }
   InventoryBrandEdit(data,callback){
    this.backend.callBackend(`${Endpoints.brand.inventory}/brand`, callback, 'PUT', data)
   }
   InventoryWhiteBrandEdit(data,callback){
    this.backend.callBackend(`${Endpoints.brand.inventory}/whitelist-brand`, callback, 'PUT', data)
   }
   getInverntoryBrands(id,callback){
    this.backend.callBackend(`${Endpoints.brand.inventory}/brand/${id}`, callback, 'GET')
}
  getInventoryBrandsWhite(id,callback){
    this.backend.callBackend(`${Endpoints.brand.inventory}/whitelist-brand/${id}`, callback, 'GET') 
  }
deleteBrandInventory(id,callback){
    this.backend.callBackend(`${Endpoints.brand.inventory}/brand/${id}`, callback, 'DELETE')
}
deleteWhiteBrandInventory(id,callback){
    this.backend.callBackend(`${Endpoints.brand.inventory}/whitelist-brand/${id}`, callback, 'DELETE') 
}
purchaserCheck(id, callback) {
    this.backend.callBackend(`${Endpoints.purchaser.private}/${id}/purchaser-profile`, callback)
}

brandSearch(id,brand,callback){
    this.backend.callBackend(`${Endpoints.purchaseOrder.brand}/${id}/${brand}`, callback)
}

createOrderThreshold(data,callback){
    this.backend.callBackend(`${Endpoints.purchaseOrder.orderSeacrh}/purchaser-order-threshold`, callback,'POST',data)
}

getOrderThreshold(id,callback){
    this.backend.callBackend(`${Endpoints.purchaseOrder.orderSeacrh}/purchaser-order-threshold/purchaser/${id}/all`, callback,'GET',)
}
deleteOrderThreshold(id,callback){
    this.backend.callBackend(`${Endpoints.purchaseOrder.orderSeacrh}/purchaser-order-threshold/${id}`, callback,'DELETE')   
}

orderReferenceId(id,callback){
    this.backend.callBackend(`${Endpoints.purchaseOrder.orderRef}/order_reference/${id}`, callback,'GET',) 
}

purchaserAll(callback){
    this.backend.callBackend(`${Endpoints.purchaseOrder.billing}/all`, callback,'GET')  
}
resetPassword(name,callback){
    this.backend.callBackend(`${Endpoints.purchaseOrder.private}/${name}/regenerate-password`, callback,'GET')   
}
gifcardTypeBanned(data,callback){
    this.backend.callBackend(`${Endpoints.purchaseOrder.orderSeacrh}/purchaser/card`, callback,'POST',data)
}
removecardTypeBanned(id,callback){
    this.backend.callBackend(`${Endpoints.purchaseOrder.orderSeacrh}/purchaser/card/${id}`, callback,'DELETE',)
}
}
